import axios from "axios";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import moment from "moment";

class ProjectStore {
  createNewProjectModalVisible = false;
  createNewProjectModalVisibleV2 = false;
  addToProjectModalVisible = false;
  addTagsModalVisible = false;
  parentNode = null;
  clients = [];
  projects = [];
  years = [];

  constructor() {
    makeAutoObservable(this);
  }
  setParentNode(id, category, year) {
    this.parentNode = {id, category, year};
    
  }
  removeParentNode() {
    this.parentNode = null;
    
  }
  setCreateNewProjectModalVisible(value, data = {}) {
    this.createNewProjectModalVisible = value;
    this.preselectedClientName = data.clientName || null;
    this.preselectedYear = data.year || null;
   
  }
  setCreateNewProjectModalVisibleV2(value, data = {}) {
    this.createNewProjectModalVisibleV2 = value;
    this.preselectedClientName = data.clientName || null;
    this.preselectedYear = data.year || null;
    
  }
  setAddToProjectModalVisible(value) {
    this.addToProjectModalVisible = value;
  }

  setAddTagsModalVisible(value) {
    this.addTagsModalVisible = value;
  }

  async createNewProject(payload) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Project/CreateProject`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success(response.data.message);
              resolve(response.data.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }
  async updateProjectName(id, name) {
    try {
      const payload =
      {
          projectId : id,
          projectName : name
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Project/UpdateProject`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success(response.data.message);
              resolve(response.data.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }
  async getClients(year = moment().year()) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Project/getClient`, null, {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              year: year,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.clients = response.data.data;
              resolve(this.clients);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getProjects(payload) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Project/getProjectName`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.projects = response.data.data;
              resolve(this.projects);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getProjectDetails(projectId) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Project/GetProjectDetails/${projectId}`)
          .then((response) => {
            if (response.status === 200) {
              resolve(response.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getSharedProject(projectId) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Project/ViewSharedProject/${projectId}`)
          .then((response) => {
            if (response.status === 200) {
              console.log("response.data.data", response.data.data);

              resolve(response.data.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async getYears() {
    try {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Project/GetProjectYear`)
          .then((response) => {
            if (response.status === 200) {
              this.years = response.data.data;
              resolve(true);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async saveProject(data) {
   
    try {
      return new Promise((resolve, reject) => {
        const payload = {
          projectId: data.projectId,
          foldersWithSamples: data.folders.map((folder) => ({
            folderId: folder.isNew ? null : folder.id,
            folderName: folder.name,
            voiceSamples: folder.children.map((file) => ({
              talentId: file.talent_id,
              sampleId: file.sample_id,
              samplePath: file.filePath
                .replace(process.env.REACT_APP_BASE_URL, "")
                .replace(/^\/+/, ""),
              talentName: file.talent_name || "",
              fileName: file.name || "",
              isDeleted: file.isDeleted ? true : false,
              isclientselected: false,
            })),
            isDeleted: folder.isDeleted ? true : false,
          })),
        };
        axios
          .post(`/api/Project/saveProject`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success(response.data.message);

              resolve(response.data.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async deleteProject(payload) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/Project/deleteProject`, {
            data: payload,
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              resolve(true);
              this.projects = this.projects.filter(
                (project) => project.project_id !== payload.projectId
              );
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async deleteYear(year) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/Project/deleteYear`, {
            data: { projectYear: year },
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              resolve(true);
              this.years = this.years.filter((y) => y !== year);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async deleteClient(data) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/Project/deleteClient`, {
            data: { clientName: data.clientName, projectYear: data.year },
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              resolve(true);
              this.clients = this.clients.filter((c) => c !== data.clientName);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async deleteSampleProject(sampleId) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/Project/deleteSampleProject`, {
            sampleId,
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              resolve(true);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async addTags(payload) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Voice/ModifyDropdownData`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              resolve(true);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async createClientFavorite(payload) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/Project/ClientFavorite`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            console.log("response", response);

            if (response.data.status) {
              toast.success(response.data.message);
              resolve(response.data.data);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }
}

const projectStore = new ProjectStore();
export default projectStore;
